import Vue from 'vue'
import store from './store'
import Router from 'vue-router'

// const Home = () => import(/* webpackChunkName: "home" */'./components/Home/Home')
// const Contratacao = () => import(/* webpackChunkName: "contratacao" */'./components/Contratacao/Contratacao')
const ProtectedBag = () => import(/* webpackChunkName: "ProtectedBag" */'./components/ProtectedBag/ProtectedBag')
const ProtectedBagAccount = () => import(/* webpackChunkName: "ProtectedBagaccount" */'./components/ProtectedBag/ProtectedBagAccount')
const Renewal = () => import(/* webpackChunkName: "renewal" */'./components/renewal/Renewal')
const RenewalSearch = () => import(/* webpackChunkName: "renewalsearch" */'./components/renewal/RenewalSearch')
const RenewalConfirmation = () => import(/* webpackChunkName: "renewalconfirmation" */'./components/renewal/_components/RenewalConfirmation')
const RenovacaoSite = () => import(/* webpackChunkName: "renovacaosite" */'./components/RenovacaoSite/index')
const Upload = () => import(/* webpackChunkName: "upload" */'./components/Upload/Upload')
const Cadastro = () => import(/* webpackChunkName: "cadastro" */'./components/Cadastro/Cadastro')
const Confirmacao = () => import(/* webpackChunkName: "confirmacao" */'./components/Confirmacao/Confirmacao')
const UnavailableDeviceFeedback = () => import(/* webpackChunkName: "unavailabledevicefeedback" */'./components/renewal/_components/UnavailableDeviceFeedback.vue')
// const HomeWithoutLead = () => import(/* webpackChunkName: "homewithoutlead" */ './components/Home/HomeWithoutLead')
const Maintenance = () => import(/* webpackChunkName: 'maintenance' */ './components/Maintenance')

const originalPush = Router.prototype.push
Router.prototype.push = function push (location) {
  return originalPush
    .call(this, location)
    .catch(error => {
      if (error.name === 'NavigationDuplicated') return
      throw error
    })
}

Vue.use(Router)

const productInformation = process.env.VUE_APP_PRODUCT_NAME === 'seguro-equipamentos-portateis'
  ? {
      title: 'Seguro Equipamentos Portáteis - Eletrônicos | Ciclic',
      link: 'https://www.ciclic.com.br/seguro-equipamentos-portateis/'
    }
  : {
      title: 'Seguro Celular Ciclic: a cobertura que seu aparelho precisa!',
      link: 'https://www.ciclic.com.br/seguro-celular/'
    }

const routerConfig = {
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      beforeEnter (to, from, next) {
        const { partner } = store.state.appSettings

        if (partner && partner.slug) {
          const linkPartner = {
            livelo: 'https://www.ciclic.com.br/seguro-equipamentos-portateis/parceria/livelo/?client_id=key-livelo-prd&utm_source=livelo_portateis',
            leadslivelo: 'https://www.ciclic.com.br/seguro-equipamentos-portateis/parceria/leads-livelo/?client_id=key-leadslivelo-external-prd&utm_source=leads-livelo_portateis',
            dotz: 'https://www.ciclic.com.br/seguro-equipamentos-portateis/parceria/dotz/?client_id=key-dotz-external-prd&utm_source=dotz_portateis',
            passageirodeprimeira: 'https://www.ciclic.com.br/seguro-equipamentos-portateis/parceria/passageiro-de-primeira/?client_id=key-passageirodeprimeira-external-prd&utm_source=passageiro-de-primeira_portateis'
          }

          window.location.href = linkPartner[partner.slug]

          return
        }

        window.location.href = productInformation.link
      }
    },
    {
      path: '/lp',
      beforeEnter (to, from, next) {
        window.location.href = productInformation.link
      }
    },
    {
      path: '/contratacao',
      name: 'Contratacao',
      beforeEnter (to, from, next) {
        const params = new URLSearchParams(to.query).toString()
        window.location.href = `https://produtos.ciclic.com.br/seguro-equipamentos-portateis/plano/simulacao/${params ? `?${params}` : ''}`
      }
    },
    {
      path: '/upload',
      name: 'Upload',
      component: Upload
    },
    {
      path: '/cadastro',
      name: 'Cadastro',
      redirect: '/cadastro/confirmacao',
      component: Cadastro,
      children: [
        { name: 'Confirmacao', path: 'confirmacao', component: Confirmacao }
      ]
    },
    {
      path: '/renovacao',
      name: 'Renewal',
      component: Renewal
    },
    {
      path: '/renovacao/buscar',
      name: 'RenewalSearch',
      component: RenewalSearch
    },
    // new renewal ini
    {
      path: '/renovacao/aparelho-indisponivel',
      name: 'RenewalFeedback',
      component: UnavailableDeviceFeedback
    },
    {
      path: '/renovacao/confirmacao',
      name: 'RenewalConfirmation',
      component: RenewalConfirmation
    },
    {
      path: '/renovacao-site',
      name: 'RenovacaoSite',
      component: RenovacaoSite
    },
    {
      path: '/seguro-adicional',
      name: 'ProtectedBag',
      component: ProtectedBag
    },
    {
      path: '/seguro-adicional/conta',
      name: 'ProtectedBagAccount',
      component: ProtectedBagAccount
    },
    {
      path: '*',
      redirect: '/'
    }
  ],
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else if (to.hash) {
      return { selector: to.hash }
    } else {
      return { x: 0, y: 0 }
    }
  }
}

if (process.env.VUE_APP_MAINTENANCE === 'true') {
  // eslint-disable-next-line no-return-assign
  routerConfig.routes.forEach(route => route.component = Maintenance)
}

const router = new Router(routerConfig)

router.beforeEach(async (to, from, next) => {
  if (!store.state.appSettings.hasLoaded) {
    await store.dispatch('init')
  }

  if (!store.state.policyUuid && store.state.lead.uuid) {
    // Atualiza o step no lead
    store.state.lead.step = to.name
    store.dispatch('actionPatchLead')

    // Zera o contador
    clearInterval(window.leadInterval)

    // Ativa o contador
    window.leadInterval = setInterval(() => {
      store.dispatch('actionPatchLead')
    }, 300000)
  }

  next()
})

router.afterEach(() => {
  Vue.nextTick(() => {
    document.title = productInformation.title
  })
})

export default router
